module.exports = __webpack_public_path__ + "img/hr-wooden-particle-17.ce83caa3.png";